import React, {FunctionComponent} from "react";
import Collapse from "@mui/material/Collapse";
import "./OurCollapse.scss";

export type OurCollapseProps = {
  children?: React.ReactNode,
  parentIsCollapsed: boolean,
}

const OurCollapse: FunctionComponent<OurCollapseProps> = (ourCollapseProps) => {
  const {children, parentIsCollapsed} = ourCollapseProps;

  return (
    <Collapse in={parentIsCollapsed}>
      <div className="our-collapse-container">
        {children}
      </div>
    </Collapse>
  )
}

export default OurCollapse;
